import { render, staticRenderFns } from "./CodeDia.vue?vue&type=template&id=1152f937&scoped=true"
import script from "./CodeDia.vue?vue&type=script&lang=js"
export * from "./CodeDia.vue?vue&type=script&lang=js"
import style0 from "./CodeDia.vue?vue&type=style&index=0&id=1152f937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152f937",
  null
  
)

export default component.exports